import { takeLatest, delay } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'

import callAny from './helpers/call_any'
import actionTypes from 'redux/actions/actionTypes'
import quickLaunchActions from 'redux/actions/quickLaunchActions'
import { quickLaunchSync, lessonSync } from 'sync'
import formatError, { NearpodError } from './helpers/error_formatter'
import currentActivitySelector from 'redux/selectors/activity_creation/current_activity_selector'
import currentActivityIsQuickLaunchSelector from 'redux/selectors/quick_launch/current_activity_is_quick_launch'
import launchLiveLesson from './helpers/launch_live_lesson'
import errorCodes from 'helpers/enums/errorCodes'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'
import standAloneActivityTypes from 'helpers/enums/standAloneActivityTypes'

function *createOeqLesson(action) {
	try {
		if (!action.oeqUID) {
			const response = yield callAny(quickLaunchSync.createOeqLesson)
			yield put(
				quickLaunchActions.createOeqLessonSuccess(
					response.payload,
				)
			)
		}
	} catch (error) {
		const serverError = formatError(error)
		yield put(quickLaunchActions.createOeqLessonFailed(serverError))
	}
}

function *createDrawItLesson(action) {
	try {
		if (!action.drawItUID) {
			const response = yield callAny(quickLaunchSync.createDrawItLesson)
			yield put(
				quickLaunchActions.createDrawItLessonSuccess(
					response.payload,
				)
			)
		}
	} catch (error) {
		const serverError = formatError(error)
		yield put(quickLaunchActions.createDrawItLessonFailed(serverError))
	}
}

function *createCollaborateLesson() {
	try {
		const response = yield callAny(quickLaunchSync.createCollaborateLesson)
		yield put(
			quickLaunchActions.createCollaborateLessonSuccess(
				response.payload,
			)
		)
	} catch (error) {
		const serverError = formatError(error)
		yield put(quickLaunchActions.createCollaborateLessonFailed(serverError))
	}
}

function *createQlCollaborateOnInitialize(action) {
	if (action.newQuickLaunchActivity === standAloneActivityTypes.COLLABORATE) {
		yield call(createCollaborateLesson)
	}
}

function *quickLaunch() {

	function *checkStatusWithStart(presentationUid) {
		let retries = 0
		while (retries <= 30) {
			try {
				return yield call(launchLiveLesson, presentationUid, '1')
			} catch (error) {
				yield call(delay, 500)
			}
			retries++
		}
		throw new NearpodError(localErrorCodes.STATUS_RETRY_TIMEOUT)
	}

	function *callPublishWithThrowException(presentationId) {
		try {
			yield callAny(lessonSync.publishLesson, presentationId)
		} catch (error) {
			// If lesson already published we swallow the error
			// and continue execution. This is to avoid fail on retry
			if (error.error_code !== errorCodes.LESSON_ALREADY_PUBLISHED) {
				throw (error)
			}
		}
	}

	try {
		const currentActivityIsQuickLaunch = yield select(
			currentActivityIsQuickLaunchSelector,
		)

		if (currentActivityIsQuickLaunch) {

			const currentActivity = yield select(currentActivitySelector)

			yield callAny(
				lessonSync.enableLesson,
				currentActivity.presentationId,
			)
			yield call(
				callPublishWithThrowException,
				currentActivity.presentationId,
			)
			const response = yield call(
				checkStatusWithStart,
				currentActivity.presentationUid,
			)

			yield put(
				quickLaunchActions.quickLaunchLessonSuccess(
					response,
					currentActivity.presentationUid,
				)
			)

		}
	} catch (error) {
		yield put(
			quickLaunchActions.quickLaunchLessonFailed(
				formatError(error),
			),
		)
	}
}

export default [
	takeLatest(
		actionTypes.QUICK_LAUNCH_OEQ_INITIALIZE_CREATION_TOOL,
		createOeqLesson,
	),
	takeLatest(
		actionTypes.QUICK_LAUNCH_DRAW_IT_INITIALIZE_CREATION_TOOL,
		createDrawItLesson,
	),
	takeLatest(
		[
			actionTypes.OEQ_SAVE_OEQ_SUCCESS,
			actionTypes.DRAW_IT_SAVE_DRAW_IT_SUCCESS,
			actionTypes.QUICK_LAUNCH_RETRY_LAUNCH,
			actionTypes.QUICK_LAUNCH_COLLABORATE_SAVE_ACTIVITY_SUCCESS,
		],
		quickLaunch,
	),
	takeLatest(
		actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE,
		createCollaborateLesson,
	),
	takeLatest(
		actionTypes.MY_LIBRARY_INITIALIZE,
		createQlCollaborateOnInitialize,
	),
]

export {
	createOeqLesson,
	createDrawItLesson,
	quickLaunch,
	createCollaborateLesson,
}
